module.exports = __webpack_public_path__ + "img/skip.761109e6.png";